
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import { inspectionOrderApi } from "@/api/inspection";
    import baseUrl from "@/constants";
    // 检定档案
    @Component({})
    export default class InspectionArchives extends Vue {
        @Prop() private params!: any;
        dataList = [];
        checkedId = 0;
        created(){
            this.getData();
        }
        indexMethods(index: number) {
            return (this.dataList.length - index);
        }

        getData(){
            this.checkedId = this.params.orderInstrId;
            inspectionOrderApi.listOrderByInstrumentId(this.params).then((r: any) => {
                if(r.data.result === 0){
                    this.dataList = r.data.data;
                }
            });
        }
        handleRowChange (data: any) {
            if (data) {
                this.checkedId = data.id;
            }
        }
        down(row: any) {
            try {
                var obj = JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=证书", '_blank');
                return false;
            }
        }
        getCheckedId(){
            return this.checkedId;
        }
    }
